import MetadataDefinitions from '@/shared/types/metadata/metadataDefinitions.type';

import MetadataFields from '../types/metadataFields.type';
import getInitialValueByMetatype from './getInitialValueByMetatype';

type Args = {
  metadataDefinitions: MetadataDefinitions[];
  requiredLevel: 'REQUIRED' | 'OPTIONAL';
  levelConstraint: 'PRODUCT' | 'VARIANT' | 'INVENTORY' | 'ATOM';
  initialData?: Record<string, unknown>;
};

const transformMetadata = ({
  metadataDefinitions,
  requiredLevel,
  levelConstraint,
  initialData,
}: Args) => {
  const definitionsByLevel = metadataDefinitions.filter(
    (item) =>
      item.level_constraint === levelConstraint &&
      item.required_level === requiredLevel,
  );

  return definitionsByLevel.map((item) => ({
    ...item,
    value:
      initialData && item.metadata_key in initialData
        ? initialData[item.metadata_key]
        : getInitialValueByMetatype(item.metatype_id as keyof MetadataFields),
  }));
};

export default transformMetadata;
